import { Flex, Text } from "@radix-ui/themes";
import styles from "./AskAnythingButton.module.scss";
import { AiMagicIcon } from "@/v2/assets/icons/AiMagicIcon";

interface AskAnythingButtonProps {
  onClick: () => void;
}

export const AskAnythingButton = ({ onClick }: AskAnythingButtonProps) => {
  return (
    <button type="button" className={styles.button} onClick={onClick}>
      <Flex align="center" gap="1" className={styles.content}>
        <AiMagicIcon size={12} />
        <Text size="2" className={styles.label}>
          Ask Anything
        </Text>
      </Flex>
    </button>
  );
};
